<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}


</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Code::art Journal submission</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Publication, art submission, code art</p>
        <p><a href="https://code-art.xyz/">Code::art</a> is an art journal which publishes code.</p>
        <p>My submission for the first edition of this journal was a visualisation of over/under, an interpreted language written in Python which applies a basic weaving pattern onto text.</p>

        <p>This publication was edited by Sy Brand</p>


      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/codeart/codeart.png"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/codeart/overunder_scan.png"></b-img>
      </b-col>
  </b-row>
  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'CodeartPage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
